import { type StateCreator } from 'zustand';

import { type SmartResizeRetryIntervention } from '../types';
import { revokeBlobObjectUrls } from '../utils/revokeBlobObjectUrls';

export type SmartResizeRetrySlice = {
  intervention: SmartResizeRetryIntervention | null;
  interventionObjectUrls: string[];
  selectedSuggestionIds: string[];
  clearIntervention: () => void;
  setIntervention: (intervention: SmartResizeRetryIntervention, objectUrlsToRevoke?: string[]) => void;
  toggleSuggestion: (id: string) => void;
};

export type CreateSmartResizeRetrySlice = () => StateCreator<SmartResizeRetrySlice, [], [], SmartResizeRetrySlice>;

export const createSmartResizeRetrySlice: CreateSmartResizeRetrySlice = () => (set) => ({
  clearIntervention: () =>
    set((state) => {
      revokeBlobObjectUrls(state.interventionObjectUrls);

      return { intervention: null, interventionObjectUrls: [], selectedSuggestionIds: [] };
    }),
  intervention: null,
  interventionObjectUrls: [],
  selectedSuggestionIds: [],
  setIntervention: (intervention, objectUrlsToRevoke = []) =>
    set((state) => {
      revokeBlobObjectUrls(state.interventionObjectUrls);

      return { intervention, interventionObjectUrls: objectUrlsToRevoke, selectedSuggestionIds: [] };
    }),
  toggleSuggestion: (id) =>
    set((state) => ({
      selectedSuggestionIds: state.selectedSuggestionIds.includes(id)
        ? state.selectedSuggestionIds.filter((selectedId) => selectedId !== id)
        : [...state.selectedSuggestionIds, id],
    })),
});
